import { useTranslation } from 'react-i18next'
import { AccountHomeLink } from '../AccountHomeLink/AccountHomeLink'
import { PersonalizedNavItem, usePersonalizedNav } from './usePersonalizedNav'

import classes from './PersonalNav.module.scss'
import classNames from 'classnames'
import { HomeToasts } from '../HomeToasts/HomeToasts'

type PersonalNavProps = {
  isMedicareAdvantage: boolean
  isImmunosuppressiveDrugCoverage: boolean
  isEMsnEnrolled: boolean
  isLoading: boolean
}
export const PersonalNav = (props: PersonalNavProps) => {
  const {
    isMedicareAdvantage,
    isImmunosuppressiveDrugCoverage,
    isEMsnEnrolled,
    isLoading
  } = props
  const { t } = useTranslation('accountHome')

  const { items, extraItems } = usePersonalizedNav({
    isMedicareAdvantage,
    isImmunosuppressiveDrugCoverage,
    isEMsnEnrolled
  })

  const itemClasses = ({ hideDesktop, hideMobile }: PersonalizedNavItem) => {
    return classNames('my-u-lg-basis--1/3 my-u-flex-grow-1', {
      'ds-u-display--none': hideMobile,
      'ds-u-md-display--block': !hideDesktop
    })
  }

  return (
    <div className="">
      <h2 className="ds-text-heading--xl ds-u-margin-bottom--3">
        {t('personalNav.heading')}
      </h2>

      <HomeToasts />
        <ul className={`${classes.container} ds-c-list--bare ds-u-padding-left--0`}>
          <>
            {items.map((item) => (
              <li
                className={`${itemClasses(item)} ${classes.item}`}
                key={item.id}
              >
                <AccountHomeLink item={item.id} isLoading={isLoading} />
              </li>
            ))}
          </>
          <>
            {extraItems.map((item) => (
              <li
                className={`${itemClasses(item)} ${classes.extraItem}`}
                key={item.id}
              >
                <AccountHomeLink item={item.id} isLoading={isLoading} />
              </li>
            ))}
          </>
        </ul>
    </div>
  )
}
